export const environment = {
  production: true,
  backend: 'https://app-api.multisite-esk.com/',
  cognito: {
    region: 'Tokyo',
    userPoolId: 'ap-northeast-1_BleQ5Z7lf',
    userPoolWebClientId: '777167evbr0arsmslo57h9jcsv',
  },
  googleAnalyticsMeasurementId: '',
  GoogleTagManagerId: '',
};
